import { type CSSProperties, type ReactNode } from 'react'

import styled from 'styled-components'

interface BlackButtonProps {
    children: ReactNode
    style?: CSSProperties
    onClick: () => void
}

export const BlackButton = ({ children, onClick, style }: BlackButtonProps) => {
    return (
        <Button style={style} onClick={onClick}>
            {children}
        </Button>
    )
}

const Button = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 0 2rem;
    border-radius: 16rem;
    line-height: 1.7rem;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #fff;
    background: linear-gradient(157.59deg, #181920 0%, #0f0f13 100%);
    cursor: pointer;
`
